import { render } from "./ModalYandexCaptcha.vue?vue&type=template&id=644b1971"
import script from "./ModalYandexCaptcha.vue?vue&type=script&lang=js"
export * from "./ModalYandexCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__